/** Raw (as-typed) filter-bar state -- all string-backed so every input stays
 * a simple controlled component; parsed/converted at the point of use. */
export type RawFilters = {
  bookingId: string;
  medicalExaminer: string;
  referrer: string;
  examinee: string;
  appointmentDate: string;
  secureAndSwitch: "all" | "yes" | "no";
  matchStatus: "all" | "MATCHED_BY_ID" | "MATCHED_BY_EMAIL" | "UNMATCHED";
  withDocs: boolean;
};

export const EMPTY_FILTERS: RawFilters = {
  bookingId: "",
  medicalExaminer: "",
  referrer: "",
  examinee: "",
  appointmentDate: "",
  secureAndSwitch: "all",
  matchStatus: "all",
  withDocs: false,
};
